module.exports = "pegasus_template/assets/follow-us.png";